import { render } from "./PercentageCard.vue?vue&type=template&id=7327b704"
import script from "./PercentageCard.vue?vue&type=script&lang=js"
export * from "./PercentageCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__